import { Image, ImageContainer } from './styles';

export const ImageFitContainer = ({ src }: any) => {
  return (
    <ImageContainer>
      <Image src={src} />
    </ImageContainer>
  );
};
